module.exports = __webpack_public_path__ + "static/media/LOGO.7189e226.svg";